import type { CrmCardTypeKey, CrmDraftModeKey, CrmLaneKey } from '@src/components/sco/Admin/AiCrm/data/types'
import type { IconType } from 'react-icons'
import {
  LuBan,
  LuLightbulb,
  LuMessageSquareText,
  LuRuler,
  LuScale,
  LuServer,
  LuUser,
  LuZap,
} from 'react-icons/lu'

/**
 * Lane colors and words, as Wil's handoff uses them: orange is a person, green is automatic,
 * violet is a draft for review, gray is no reply. Palettes are Chakra color palettes, so a
 * screen recolors with `colorPalette` and never with a hex.
 */
export type CrmPalette = 'orange' | 'green' | 'purple' | 'gray' | 'yellow' | 'red' | 'teal' | 'blue'

export type LaneMeta = {
  label: string
  /** The second line on the lane tiles. */
  hint: string
  palette: CrmPalette
  Icon: IconType
}

export const LANE: Record<CrmLaneKey, LaneMeta> = {
  none: { label: 'No reply', hint: 'Clear it', palette: 'gray', Icon: LuBan },
  auto: { label: 'Auto', hint: 'AI sends', palette: 'green', Icon: LuZap },
  assist: { label: 'AI assist', hint: 'AI drafts', palette: 'purple', Icon: LuMessageSquareText },
  human: { label: 'Pure human', hint: 'Route it', palette: 'orange', Icon: LuUser },
}

export const LANE_ORDER: CrmLaneKey[] = ['none', 'auto', 'assist', 'human']

export const CARD_KIND: Record<
  CrmCardTypeKey,
  { label: string; hint: string; palette: CrmPalette; Icon: IconType }
> = {
  method: { label: 'Methodology', hint: 'The Startups.com way', palette: 'purple', Icon: LuRuler },
  advice: { label: 'Advice', hint: 'General startup advice', palette: 'orange', Icon: LuLightbulb },
  system: { label: 'System', hint: 'How our systems work', palette: 'teal', Icon: LuServer },
  policy: { label: 'Policy', hint: 'What we will and won’t do', palette: 'yellow', Icon: LuScale },
}

export const CARD_KIND_ORDER: CrmCardTypeKey[] = ['method', 'advice', 'system', 'policy']

export function draftModeLabel(mode: CrmDraftModeKey | null | undefined) {
  if (mode === 'pre-drafted') {
    return { label: 'Pre-drafted', palette: 'yellow' as const }
  }
  if (mode === 'briefing-first') {
    return { label: 'Briefing first', palette: 'red' as const }
  }
  return null
}
